import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class UserAvatar extends PureComponent {
  render() {
    const { photoUrl, wrapperClass, clickHandler, name } = this.props

    return (
      <div className={wrapperClass || 'avatar'}>
        <div className="user-photo-wrapper" onClick={clickHandler || undefined}>
          <img src={photoUrl} alt={name} />
        </div>
      </div>
    )
  }
}

UserAvatar.propTypes = {
  photoUrl: PropTypes.string,
  wrapperClass: PropTypes.string,
  clickHandler: PropTypes.func,
  name: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/UserAvatar.js